import React from 'react';
import logo from '../assets/logo.jpg';
import qualityImage from '../assets/quality-machine.jpg';

const QualitySection = () => {
  return (
    <section className="bg-white py-20" id="quality">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Top Section */}
        <div className="grid md:grid-cols-2 gap-12 mb-16">
          {/* Left Content */}
          <div className="space-y-8">
            <img src={logo} alt="Sun Energy Logo" className="h-20 w-auto" />
            
            <div>
              <p className="text-orange-500 font-bold mb-4 text-2xl">
                ADVANCED TECHNOLOGY AND MATERIALS
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-blue-900 leading-tight">
                Quality Product with<br />
                Latest Tecnology
              </h2>
            </div>

            <div className="space-y-4 text-gray-700 text-xl text-left">
              <p>
                We use N-Type TOPCon 16BB cells for high energy output and durability.
              </p>
              <p>
                Round Ribbon Stringers enhances conductivity, reduce energy loss, and minimize microcracks.
              </p>
              <p>
                High-Transmissivity Glass with Low-iron, and mislite finish glass optimizes light absorption and ensures long-lasting protection.
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={qualityImage}
              alt="Quality Testing Machine"
              className="w-full h-full object-cover rounded-lg"
            />
          </div>
        </div>

        {/* Bottom Blue Section */}
        <div className="bg-blue-900 rounded-2xl p-12 text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-8">
            Unmatched Quality Assurance
          </h3>
          
          <div className="space-y-6">
            <p className="text-xl text-left">
              Precise Power Rating where each panel is tested with Myanmar's only{' '}
              <span className="font-bold">Sun Simulator</span>{' '}
              for accurate performance verification.
            </p>

            <p className="text-xl text-left">
              Defect-Free Panels obtained with rigorous{' '}
              <span className="font-bold">EL Testing</span>{' '}
              during production to ensure flawless panels every time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualitySection;